const urlRelatoriosLog = "/v1/RelatoriosDeLog";

const service = {
  methods: {
    $obterRelatorioLogFAQ(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogFAQ`, params);
    },
    $obterRelatorioLogCSVFAQ(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogFaqCsv`, params);
    },
    $obterRelatorioLogPDFFAQ(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogFaqPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;